<footer
  #footerContainer
  class="page-footer-container"
  [class.page-footer-container--open]="isDrawerOpen"
>
  <button
    *ngIf="footerConfig.dismissButtonText"
    (click)="handleDismiss()"
    class="page-footer-container__button-dismiss"
  >
    {{ footerConfig.dismissButtonText }}
  </button>
  <button
    *ngIf="footerConfig.submitButtonText"
    (click)="handleSubmit()"
    class="page-footer-container__button-submit"
  >
    {{ footerConfig.submitButtonText }}
  </button>
  <button
    *ngIf="footerConfig.deleteButtonText"
    (click)="handleDelete()"
    class="page-footer-container__button-delete"
  >
    {{ footerConfig.deleteButtonText }}
  </button>
</footer>
<div style="height: 80px; visibility: hidden"></div>
